import { Status } from 'types/worker_fee_update_application'
import axiosForGigbaseBiz from '../config'
import { DataResponse } from '../response'
import { mergeURL } from './lib'

const resource = 'worker_fee_update_applications'

export const requests = {
  update: async (params: { id: number; status: Status }) => {
    return await axiosForGigbaseBiz.patch<DataResponse>(
      mergeURL(resource, params.id.toString()),
      params,
    )
  },
}
